import React, { useState } from "react";
import axios from "axios";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");
    try {
      const res = await axios.post(
        "https://client.fexila.com/api/contact",
        form,
      );
      setStatus(res.data.message);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      setStatus(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-light section" id="contact">
      <div className="container">
        {/* Heading */}
        <h2 className="text-center mb-3">Get In Touch</h2>
        <div className="col-lg-6 col-md-8 col-11 mx-auto text-center">
          <p className="mb-5">
            Reach out for any questions or support. Our team is here to help and
            ensure you have an exceptional experience.
          </p>
        </div>

        {/* Contact Form */}
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-12">
            <form className="row g-3" onSubmit={handleSubmit}>
              <div className="col-md-6 d-flex justify-content-center">
                <input
                  type="text"
                  name="name"
                  className="form-control form-control-responsive"
                  placeholder="Name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6 d-flex justify-content-center">
                <input
                  type="email"
                  name="email"
                  className="form-control form-control-responsive"
                  placeholder="Email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="d-flex justify-content-center">
                <input
                  type="tel"
                  name="phone"
                  className="form-control form-control-responsive"
                  placeholder="Phone"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="d-flex justify-content-center">
                <textarea
                  name="message"
                  className="form-control form-control-responsive"
                  rows="6"
                  placeholder="Write comments"
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="btn btn-primary px-4"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Sending...
                    </>
                  ) : (
                    "Send Message"
                  )}
                </button>
              </div>
            </form>

            {status && (
              <p className="text-center mt-3 text-success">{status}</p>
            )}
          </div>
        </div>

        {/* Call to Action */}
        <div className="row pt-5">
          <div className="col-lg-9 col-md-10 text-center mx-auto">
            <p className="text-dark fs-5">
              Join 1200+ businesses using Fexila — start free today
            </p>
            <a
              href="https://app.fexila.com/register"
              className="btn btn-primary btn-responsive"
            >
              <img
                src="assets/images/lock.png"
                alt=""
                style={{ display: "inline-block", marginRight: "6px" }}
              />
              Start your 14-day FREE trial
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
